// export const redColor = [
//     {
//         r: 255,
//         g: 160,
//         b: 122
//     },
//     {
//         r: 240,
//         g: 128,
//         b: 128
//     },
//     {
//         r: 250,
//         g: 128,
//         b: 114
//     },
//     {
//         r: 233,
//         g: 150,
//         b: 122
//     },
//     {
//         r: 255,
//         g: 99,
//         b: 71
//     },
//     {
//         r: 205,
//         g: 92,
//         b: 92
//     },
//     {
//         r: 255,
//         g: 69,
//         b: 0
//     },
//     {
//         r: 220,
//         g: 20,
//         b: 60
//     },
//     {
//         r: 255,
//         g: 153,
//         b: 153
//     },
//     {
//         r: 255,
//         g: 105,
//         b: 97
//     },
//     {
//         r: 254,
//         g: 111,
//         b: 94
//     },
//     {
//         r: 228,
//         g: 113,
//         b: 122
//     },
//     {
//         r: 253,
//         g: 94,
//         b: 83
//     },
//     {
//         r: 230,
//         g: 103,
//         b: 113
//     },
//     {
//         r: 255,
//         g: 110,
//         b: 74
//     },
//     {
//         r: 255,
//         g: 83,
//         b: 73
//     },
//     {
//         r: 255,
//         g: 64,
//         b: 64
//     },
//     {
//         r: 233,
//         g: 116,
//         b: 81
//     },
//     {
//         r: 255,
//         g: 90,
//         b: 54
//     },
//     {
//         r: 204,
//         g: 102,
//         b: 102
//     },
//     {
//         r: 255,
//         g: 53,
//         b: 94
//     },
//     {
//         r: 235,
//         g: 76,
//         b: 66
//     },
//     {
//         r: 234,
//         g: 60,
//         b: 83
//     },
//     {
//         r: 239,
//         g: 48,
//         b: 56
//     },
//     {
//         r: 255,
//         g: 0,
//         b: 63
//     },
//     {
//         r: 255,
//         g: 0,
//         b: 56
//     },
//     {
//         r: 255,
//         g: 0,
//         b: 79
//     },
//     {
//         r: 255,
//         g: 36,
//         b: 0
//     },
//     {
//         r: 255,
//         g: 40,
//         b: 0
//     },
//     {
//         r: 255,
//         g: 56,
//         b: 0
//     },
//     {
//         r: 255,
//         g: 58,
//         b: 0
//     },
//     {
//         r: 206,
//         g: 32,
//         b: 41
//     },
//     {
//         r: 242,
//         g: 0,
//         b: 60
//     },
//     {
//         r: 227,
//         g: 0,
//         b: 34
//     },
//     {
//         r: 232,
//         g: 0,
//         b: 13
//     }
// ]

export const redColor = [
    {
        r: 65535,
        g: 41120,
        b: 31354
    },
    {
        r: 60652,
        g: 60395,
        b: 48573
    }
]

export const greenColor = [
    {
        r: 39064,
        g: 64507,
        b: 39064
    },
    {
        r: 39064,
        g: 65535,
        b: 39064
    },
    {
        r: 44204,
        g: 57825,
        b: 44975
    }
]


// export const greenColor = [
//     {
//         r: 152,
//         g: 251,
//         b: 152
//     },
//     {
//         r: 144,
//         g: 238,
//         b: 144
//     },
//     {
//         r: 143,
//         g: 188,
//         b: 143
//     },
//     {
//         r: 147,
//         g: 197,
//         b: 114
//     },
//     {
//         r: 173,
//         g: 255,
//         b: 47
//     },
//     {
//         r: 0,
//         g: 255,
//         b: 0
//     },
//     {
//         r: 0,
//         g: 255,
//         b: 127
//     },
//     {
//         r: 127,
//         g: 255,
//         b: 0
//     },
//     {
//         r: 50,
//         g: 205,
//         b: 50
//     },
//     {
//         r: 0,
//         g: 250,
//         b: 154
//     },
//     {
//         r: 124,
//         g: 252,
//         b: 0
//     },
//     {
//         r: 60,
//         g: 179,
//         b: 113
//     },
//     {
//         r: 233,
//         g: 255,
//         b: 219
//     },
//     {
//         r: 208,
//         g: 240,
//         b: 192
//     },
//     {
//         r: 236,
//         g: 235,
//         b: 189
//     },
//     {
//         r: 216,
//         g: 228,
//         b: 188
//     },
//     {
//         r: 152,
//         g: 255,
//         b: 152
//     },
//     {
//         r: 152,
//         g: 251,
//         b: 152
//     },
//     {
//         r: 172,
//         g: 225,
//         b: 175
//     },
//     {
//         r: 173,
//         g: 223,
//         b: 173
//     },
//     {
//         r: 168,
//         g: 228,
//         b: 160
//     },
//     {
//         r: 144,
//         g: 238,
//         b: 144
//     },
//     {
//         r: 118,
//         g: 255,
//         b: 122
//     },
//     {
//         r: 163,
//         g: 193,
//         b: 173
//     },
//     {
//         r: 197,
//         g: 227,
//         b: 132
//     },
//     {
//         r: 201,
//         g: 220,
//         b: 135
//     },
//     {
//         r: 119,
//         g: 221,
//         b: 119
//     },
//     {
//         r: 169,
//         g: 186,
//         b: 157
//     },
//     {
//         r: 143,
//         g: 188,
//         b: 143
//     },
//     {
//         r: 158,
//         g: 253,
//         b: 56
//     },
//     {
//         r: 116,
//         g: 195,
//         b: 101
//     },
//     {
//         r: 80,
//         g: 200,
//         b: 120
//     },
//     {
//         r: 178,
//         g: 236,
//         b: 93
//     }
// ]
